"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _cccisdApollo = require("cccisd-apollo");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _FixedSessionPlayer = _interopRequireDefault(require("./FixedSessionPlayer"));
var _assignment = _interopRequireDefault(require("./assignment.graphql"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function SessionData(_ref) {
  var _ref$questprojectIds = _ref.questprojectIds,
    questprojectIds = _ref$questprojectIds === void 0 ? [] : _ref$questprojectIds,
    groups = _ref.groups,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Session Data' : _ref$title,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description;
  var _useParams = (0, _reactRouterDom.useParams)(),
    id = _useParams.id;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    assignmentData = _useState4[0],
    setAssignmentData = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    config = _useState6[0],
    setConfig = _useState6[1];
  var _useState7 = (0, _react.useState)(groups && (groups.find(function (group) {
      return group.groupId === Number(id);
    }) || groups[0])),
    _useState8 = _slicedToArray(_useState7, 2),
    currentGroup = _useState8[0],
    setCurrentGroup = _useState8[1];
  (0, _react.useEffect)(function () {
    initializeData();
  }, [currentGroup]);
  function initializeData() {
    return _initializeData.apply(this, arguments);
  }
  function _initializeData() {
    _initializeData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (currentGroup) {
              setIsLoading(true);
              getAssignmentData().then(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        _context2.n = 1;
                        return setConfig(data.settings.navigationSettings);
                      case 1:
                        _context2.n = 2;
                        return setAssignmentData(data);
                      case 2:
                        setIsLoading(false);
                      case 3:
                        return _context2.a(2);
                    }
                  }, _callee2);
                }));
                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }())["catch"](function (err) {
                return console.error(err);
              });
            } else {
              setIsLoading(false);
            }
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _initializeData.apply(this, arguments);
  }
  function getAssignmentData() {
    return _getAssignmentData.apply(this, arguments);
  }
  function _getAssignmentData() {
    _getAssignmentData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var res;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _context4.n = 1;
            return _cccisdApollo.client.query({
              query: _assignment["default"],
              fetchPolicy: 'network-only',
              variables: {
                groupId: questprojectIds,
                assignmentHandle: 'session_data',
                pawnId: currentGroup.pawnId
              }
            });
          case 1:
            res = _context4.v;
            return _context4.a(2, res.data.flows.assignment);
        }
      }, _callee4);
    }));
    return _getAssignmentData.apply(this, arguments);
  }
  var changeGroup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return setIsLoading(true);
          case 1:
            _context.n = 2;
            return setCurrentGroup(e);
          case 2:
            setIsLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function changeGroup(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!isLoading && groups.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, "No groups were found.", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "Thinking Emoji"
    }, "\uD83E\uDD14")), /*#__PURE__*/_react["default"].createElement("p", null, "Please verify that groups have been created for this site.")));
  }
  if (!isLoading && id && !groups.find(function (group) {
    return group.groupId === Number(id);
  })) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("h2", null, "Invalid Group ID provided in the URL.", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "Gasp Emoji"
    }, "\uD83D\uDE31")));
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: isLoading
  }, currentGroup && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement("strong", null, title)), /*#__PURE__*/_react["default"].createElement("p", null, description)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-lg btn-primary dropdown-toggle",
    type: "button",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
  }, currentGroup.label), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "dropdown-menu"
  }, groups.map(function (group) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: group.groupId
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: 'dropdown-item fs-5 ' + (group.groupId === currentGroup.groupId ? 'active' : ''),
      href: "#",
      onClick: function onClick() {
        return changeGroup(group);
      }
    }, group.label));
  }))))), /*#__PURE__*/_react["default"].createElement("br", null), !isLoading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, config.sessionType === 'fixed' && /*#__PURE__*/_react["default"].createElement(_FixedSessionPlayer["default"], {
    assignmentData: assignmentData,
    currentGroup: currentGroup,
    loadData: initializeData
  }))));
}
var _default = exports["default"] = SessionData;